/** Tarayıcıya açık yapılandırma (gizli değer yok). Eksikse uygulama açılmaz, nedeni ekranda yazar. */
export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL as string | undefined,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined,
  apiUrl: ((import.meta.env.VITE_API_URL as string | undefined) ?? "http://localhost:8787").replace(
    /\/$/,
    "",
  ),
};

export const missingEnv = (["supabaseUrl", "supabaseAnonKey"] as const).filter((k) => !env[k]);
